import React, { useEffect, useState } from 'react';

export default function KeyValueEditor({
  keyPair,
  setKeyPair,
  onKeyPairRemove,
}) {
  const [keyValue, setKeyValue] = useState(keyPair);
  const [debouncedKeyValue, setDebouncedKeyValue] = useState(keyValue);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedKeyValue(keyValue);
    }, 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, [keyValue]);

  useEffect(() => {
    setKeyPair(debouncedKeyValue);
    // eslint-disable-next-line
  }, [debouncedKeyValue]);

  const handleOnChange = (e) => {
    setKeyValue((prevState) => ({
      ...prevState,
      id: keyValue.id,
      [e.target.name]: e.target.value,
    }));
  };
  return (
    <div className='flex gap-3 mb-3 items-center group'>
      <div className="flex-1">
        <input
          className="px-4 py-2.5 text-sm w-full border-2 border-gray-200 rounded-lg hover:border-[#fdb814] focus:outline-none focus:ring-2 focus:ring-[#fdb814]/20 focus:border-[#fdb814] transition-all duration-200 bg-white"
          placeholder='Key'
          name='keyItem'
          onChange={(e) => handleOnChange(e)}
        />
      </div>
      <div className="flex-1">
        <input
          className="px-4 py-2.5 text-sm w-full border-2 border-gray-200 rounded-lg hover:border-[#fdb814] focus:outline-none focus:ring-2 focus:ring-[#fdb814]/20 focus:border-[#fdb814] transition-all duration-200 bg-white"
          placeholder='Value'
          name='valueItem'
          onChange={(e) => handleOnChange(e)}
        />
      </div>
      <button 
        className="p-2.5 rounded-lg text-gray-400 hover:text-red-600 hover:bg-red-50 transition-all duration-200 flex-shrink-0"
        onClick={() => onKeyPairRemove(keyPair)}
        title="Remove parameter"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1H9a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </button>
    </div>
  );
}
